import globals from "@lvt/globals";
import { createAsyncThunk } from "@reduxjs/toolkit";
import Ajv from "ajv";
import axios from "axios";
import applyCaseMiddleware from "axios-case-converter";

import { lvtResponseSchema, validateRequest } from "../common";


export interface ArchiveCabinet {
    cameraName: string;
    clientName: string;
    id: number;
    liveUnitName: string;
    locationName: string;
    regionName: null | string;
}

const archiveCabinetProperties = {
    cameraName: { type: "string" },
    clientName: { type: "string" },
    id: { type: "integer" },
    liveUnitName: { type: "string" },
    locationName: { type: "string" },
    regionName: { type: ["string", "null"] },
};

const archiveCabinetsSearchSchema = lvtResponseSchema({
    type: "array",
    items: {
        type: "object",
        required: Object.keys(archiveCabinetProperties),
        properties: archiveCabinetProperties,
    },
});

const archiveCabinetsSearchValidator = new Ajv().compile(archiveCabinetsSearchSchema);

const client = applyCaseMiddleware(
    axios.create({
        baseURL: globals.userdashboard.proxyUrl,
    }),
);

export const fetchArchiveCabinets = createAsyncThunk("fetchArchiveCabinets", async (_: void, { dispatch }) => {
    const request = client.get("/api/vms/legacy/archive_cabinets/search", {
        withCredentials: true,
    });

    const response = await validateRequest<Array<ArchiveCabinet>>(
        dispatch,
        request,
        archiveCabinetsSearchValidator,
        "Failed to get archive cabinets",
    );

    return response;
});
